import React, { useEffect, useRef } from 'react';
import './ContactUs.css';

const ContactUs = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.fade-in');
    elements?.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="contact" className="contact-us section-padding" ref={sectionRef}>
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-block fade-in">
              <h2>Get in Touch</h2>
              <p>
                We welcome inquiries about our collections, custom pieces, 
                and heritage craftsmanship. Our artisans are ready to create 
                something extraordinary for your table.
              </p>
            </div>

            <div className="contact-details fade-in">
              <div className="detail-item">
                <h4>Atelier & Showroom</h4>
                <p>
                  Chahine Cutlery<br />
                  Jezzine, Lebanon
                </p>
              </div>

              <div className="detail-item">
                <h4>Contact Information</h4>
                <p>
                  Phone: 07780324<br />
                  WhatsApp: +961 79 403 786<br />
                  Email: info@chahinecutlery.com<br />
                  Hours: Mon-Sat 10-6
                </p>
                <a 
                  href="https://wa.me/96179403786?text=Hello%20Chahine%20Cutlery,%20I%20would%20like%20to%20inquire%20about%20your%20products."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-contact-btn"
                >
                  <svg className="whatsapp-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                  Contact via WhatsApp
                </a>
              </div>

            
            </div>
          </div>

          <div className="contact-map-container fade-in">
            <iframe
              className="contact-map"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3311.234567890123!2d35.583253109971075!3d33.54365337361593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzPCsDMyJzM3LjIiTiAzNcKwMzUnMDAuNyJF!5e0!3m2!1sen!2slb!4v1234567890123!5m2!1sen!2slb"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Chahine Cutlery Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;